import React from 'react';
import Modal from 'react-modal';
import withMenuModals from '../../../containers/Modals/menu';
import * as styles from '../style';
import { customModalStyles, PATHS } from '../../../helpers/constants';
import ConfirmIcon from '../../Icons/Confirm';

const EditConfirmationModal = ({ modal, closeModal, history }) => {
  const close = () => {
    closeModal();
    history.push(PATHS.menu);
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={modal.showEditConfirmationMenuModal}
      onRequestClose={close}
      style={{
        ...customModalStyles,
        content: {
          ...customModalStyles.content,
          width: '90%',
          maxWidth: '450px',
          height: 'auto',
        },
      }}
    >
      <styles.Container>
        <styles.Content>
          <ConfirmIcon size="120px" />
          <styles.Title>Cardápio alterado com sucesso!</styles.Title>
        </styles.Content>
        <styles.Footer center>
          <styles.OKButton onClick={() => close()} disabled={false}>
            OK
          </styles.OKButton>
        </styles.Footer>
      </styles.Container>
    </Modal>
  );
};

export default withMenuModals(EditConfirmationModal);



// WEBPACK FOOTER //
// ./src/components/GenericModal/EditConfirmationModal/index.js